<template>
	<div class="exchange-i">
    <Header title="学生成绩查询列表" ></Header>
    <NOdata
      v-if="this.exchangeList && this.exchangeList.length == 0"
      title="未查询到任何信息"
    ></NOdata>
    <div class="exchange">
      <div
        class="item"
        v-for="(item, index) of exchangeList"
        :key="index"
      >
        <ul>
          <li class='curpepother'><span>学年学期</span>{{ item.xqmc }}</li>
          <li class='curpepother'><span>课程名称</span>{{ item.kcmc }}</li>
          <li class='curpepother'><span>学号</span>{{ item.xh }}</li>
          <li class='curpepother'><span>姓名</span>{{ item.xm }}</li>
          <li class='curpepother'><span>成绩</span>{{ item.zcj }}</li>
        </ul>
      </div>
    </div>
  </div>
  </template>
  
  <script>
  import { Api } from "@/utils/axios";
  export default {
	data() {
	  return {
		route_query:{},
		exchangeList: [],
		initParmer:"",
	  };
	},
	mounted() {
		this.route_query = JSON.parse(decodeURI(this.$route.params.route_params));
		this.getList(this.route_query);
	},
	methods: {
	  // 获取课程列表
	  async getList(query) {
		 const params = {
		   xnxq: query.xnxqId,
		   skbjId: query.skbjId
		  }
		const res = await Api.getxscjcxList(params);
		this.exchangeList = res.data;
	  }
	}
  };
  </script>
  <style lang="less" scoped>
  .exchange-i {
	.exchange {
	  padding: 1% 3% 0;
	  overflow: auto;
	  height: 90vh;
	  .item {
		background: #f8f8f8;
		border-radius: 5px;
		margin: 0 auto 3%;
		padding: 3% 0 3% 3%;
		box-sizing: border-box;
		p {
		  height: 22px;
		  font-family: PingFangSC-Medium;
		  font-size: 16px;
		  color: #212f6e;
		  letter-spacing: 0;
		  font-weight: bolder;
		  margin-bottom: 2%;
		}
		span {
		  height: 22px;
		  font-family: PingFangSC-Medium;
		  font-size: 16px;
		  color: #212f6e;
		  letter-spacing: 0;
		  font-weight: bolder;
		  margin-bottom: 2%;
		}
		ul {
		  li .curpepother{
			height: 16px;
			font-family: PingFangSC-Medium;
			font-size: 14px;
			color: #757da3;
			letter-spacing: 0;
			line-height: 16px;
			margin-bottom: 1%;
		  }
		}
		li .curpep {
		  height: auto;
			font-family: PingFangSC-Medium;
			font-size: 14px;
			color: #757da3;
			letter-spacing: 0;
			line-height: 16px;
			margin-bottom: 1%;
		}
	  }
	}
	.bottom-btn {
	  position: fixed;
	  bottom: 0;
	  left: 0;
	  width: 100%;
	  height: 60px;
	  padding-bottom: 10px;
	  padding: 0 5%;
	  background: #fff;
	  box-sizing: border-box;
  
	  button {
		width: 100%;
		height: 44px;
		background: #7469f8;
		border-radius: 3px;
		color: #fff;
	  }
	}
  }
  </style>


// WEBPACK FOOTER //
// src/components/teacher/studentCjxx/studentList.vue